import React from 'react';
import Grid from '@material-ui/core/Grid';
import {
    withTheme,
    Button,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions
} from '@material-ui/core';

const UnsavedModificationsModal = ({ theme, showModal, MODAL_TYPE, setConfirmedNavigation }) => {
    return (
        <Dialog aria-labelledby="guest-new-modal" open maxWidth="sm">
            <DialogTitle>Unsaved modifications</DialogTitle>
            <DialogContent>
                <Grid container spacing={1} justifyContent="center" alignItems="center">
                    <Grid item xs={12}>
                        <div>
                            You have unsaved modifications and you want to leave the screen. Are you
                            sure?
                        </div>
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button
                    style={{ color: theme.palette.error.main }}
                    onClick={() => {
                        setConfirmedNavigation(true);
                        showModal(MODAL_TYPE.NONE);
                    }}
                >
                    Yes
                </Button>

                <Button
                    style={{ color: theme.palette.primary.main }}
                    onClick={() => {
                        showModal(MODAL_TYPE.NONE);
                    }}
                >
                    No
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default withTheme(UnsavedModificationsModal);
